import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy} from "@angular/core";
import {MenuModel} from "../menu.model";
import {MenuEvents} from "../menu-events";
import {Subscription} from "rxjs";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {MenuCategoryData} from "../menu-entity.model";

@Component({
    selector: "woa-menu-category-selection-panel",
    templateUrl: "./menu-category-selection-panel.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuCategorySelectionPanelComponent implements OnDestroy {
    @Input() showNavIcons: boolean = true;

    IconButtonType = IconButtonType;

    private subscriptions: Subscription = new Subscription();

    constructor(public menuModel: MenuModel,
                changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(MenuEvents.menuBuilt$.subscribe(() => changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    @HostBinding("class.with-images") get withImages(): boolean {
        return this.menuModel.showCategoryImages;
    }

    selectCategory(category: MenuCategoryData): void {
        this.menuModel.selectCategory(category);
    }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu-category-selection-panel/menu-category-selection-panel.component.ts